// noinspection DuplicatedCode

import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";

import {alertService} from "../../../services/AlertService";

import TableCard from "../../../components/tablecard/TableCard";
import ModalForm from "../../../components/modal/form/ModalForm";

import {getLembur, insertLembur, lemburSelector, updateLembur} from "./lemburSlice";

import {Colors} from "../../../assets/Colors";

const LemburPage = ({}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [firstLoading, setFirstLoading] = useState(false);
    const [start, setStart] = useState(0);
    const [count, setCount] = useState(5);
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(0);
    const [search, setSearch] = useState("");
    const [searchFetch, setSearchFetch] = useState(false);
    const [insertFetch, setInsertFetch] = useState(false);
    const [updateFetch, setUpdateFetch] = useState(false);
    const [showModalAdd, setShowModalAdd] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [currentData, setCurrentData] = useState({});

    const lembur = useSelector(lemburSelector);

    useEffect(() => {
        dispatch(
            getLembur({
                start: start,
                count: count,
                search: "",
            })
        );
    }, []);

    useEffect(() => {
        if (search !== "" && lembur?.isGetSuccess && !lembur.isGetFetching) {
            let calc = lembur?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }

            let tempMaxPage = lembur.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        }

        if (search === "" && lembur?.isGetSuccess && !lembur.isGetFetching) {
            let calc = lembur?.count - 1;

            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }

            setSearchFetch(false);
            setMaxPage(Math.ceil(calc / count));
        }

        if (
            !lembur?.isGetFetching &&
            lembur?.isGetSuccess &&
            maxPage === 0 &&
            firstLoading === false
        ) {
            let calc = lembur?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }
            setMaxPage(Math.ceil(calc / count));
            setFirstLoading(true);
            dispatch(
                getLembur({
                    start: start,
                    count: count,
                    search: search,
                })
            );
        }

        if (insertFetch) {
            setInsertFetch(false);
            alertService.success(lembur.message, {
                autoClose: true,
                keepAfterRouteChange: false,
            });
            dispatch(
                getLembur({
                    start: start,
                    count: count,
                    search: search,
                })
            );
        }

        if (updateFetch) {
            setUpdateFetch(false);
            alertService.success(lembur.message, {
                autoClose: true,
                keepAfterRouteChange: false,
            });
            dispatch(
                getLembur({
                    start: start,
                    count: count,
                    search: search,
                })
            );
        }
    });

    // function handleGetLembur(params) {
    //   return dispatch(getLembur(params));
    // }

    function handleInsertLembur(param) {
        setInsertFetch(true);
        const params = {
            namaLembur: param.inputOneValue,
            golonganID: param.dropdownGolonganValue,
            tipeKaryawanID: param.dropdownTipeKaryawanValue,
            jumlahLembur: param.inputNumberOneValue,
        };
        dispatch(insertLembur(params));
    }

    function handleUpdateLembur(param) {
        setUpdateFetch(true);

        const params = {
            setupLemburID: currentData.SetupLemburID,
            namaLembur: param.inputOneValue,
            golonganID: param.dropdownGolonganValue,
            tipeKaryawanID: param.dropdownTipeKaryawanValue,
            jumlahLembur: param.inputNumberOneValue,
            status: param.status,
        };
        dispatch(updateLembur(params));
    }

    function handleSearch(searchValue) {
        let params = {
            start: 0,
            count: 5,
            search: searchValue,
        };
        dispatch(getLembur(params));

        setStart(0);
        setCount(5);
        setSearch(searchValue);
        setSearchFetch(true);
    }

    function handleUpdatePage(newPage) {
        let newStart = newPage * count - count;

        let params = {
            start: newStart,
            count: count,
            search: search,
        };
        dispatch(getLembur(params));

        setPage(newPage);
        setStart(newStart);
    }

    function handleUpdateCount(newCount) {
        let calc = lembur.count - 1;
        if (calc === 0) {
            calc = 1;
        }

        let params = {
            start: newCount === "-1" ? 0 : start,
            count: newCount === "-1" ? lembur.count : newCount,
            search: search,
        };
        dispatch(getLembur(params));

        setPage(1);
        setCount(newCount === "-1" ? lembur.count : newCount);
        setStart(newCount === "-1" ? 0 : start);
        setMaxPage(newCount === "-1" ? 1 : Math.ceil(calc / newCount));
    }

    function handleCurrentData(values) {
        setCurrentData(values);
    }

    function handleModal(status) {
        setShowModalAdd(status.showModalAdd);
        setShowModalEdit(status.showModalEdit);
    }

    if (!firstLoading) {
        return <div>loading</div>;
    } else {
        return (
            <div className="md:ml-64">
                <div style={{background: Colors.primary}} className="pt-14 pb-16 px-3 md:px-8 h-auto">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
                    </div>
                </div>

                <div className="px-3 md:px-8 h-auto -mt-32">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 px-4">
                            <TableCard
                                handleSearch={handleSearch}
                                searchPlaceholder="Lembur"
                                updatePage={handleUpdatePage}
                                updateCount={handleUpdateCount}
                                currentData={handleCurrentData}
                                currentPage={page}
                                maxPage={maxPage}
                                tableTitle="Master Lembur"
                                tableData={lembur.data}
                                colOneTitle="ID"
                                colOneData="SetupLemburID"
                                colTwoTitle="Jenis Lembur"
                                colTwoData="NamaSetupLembur"
                                colThreeTitle="Golongan"
                                colThreeData="NamaGolongan"
                                colFourTitle="Tipe Karyawan"
                                colFourData="NamaTipeKaryawan"
                                status="Status"
                                fetching={lembur.isGetFetching}
                                modal={handleModal}
                                editEnabled={true}
                            />
                        </div>
                    </div>
                </div>
                {showModalAdd && (
                    <ModalForm
                        showModal={showModalAdd}
                        addEnabled={true}
                        modal={handleModal}
                        modalTitle="Tambah Lembur"
                        dropdownGolongan={true}
                        dropdownTipeKaryawan={true}
                        inputOneTitle="Nama Lembur"
                        inputOnePlaceholder=""
                        submitButtonTitle="Submit"
                        handleSubmit={handleInsertLembur}
                    />
                )}
                {showModalEdit && (
                    <ModalForm
                        showModal={showModalEdit}
                        editEnabled={true}
                        id={currentData.SetupLemburID}
                        modal={handleModal}
                        modalTitle="Ubah Lembur"
                        dropdownGolongan={true}
                        dropdownTipeKaryawan={true}
                        dropdownGolonganValue={currentData.GolonganID}
                        dropdownTipeKaryawanValue={currentData.TipeKaryawanID}
                        inputOneTitle="Nama Lembur"
                        inputOneValue={currentData.NamaSetupLembur}
                        status={currentData.Status}
                        submitButtonTitle="Submit"
                        handleSubmit={handleUpdateLembur}
                    />
                )}
            </div>
        );
    }
};

export default LemburPage;
